import * as React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/global/layout';
import Spacing from '../components/layout/spacing/spacing';
import Hero from '../components/hero/hero';
import Lead from '../components/lead/lead';
import Lines from '../components/lines/lines';
import ModuleArea from '../components/ModularContent/ModuleArea';
import BrandTicker from '../components/ticker/ticker';
import Slider from '../components/slider/slider';
import Video from '../components/video/video';
import Intro from '../components/intro/intro';
import NewsList from '../components/news-list/news-list';
import Container from '../components/layout/container/container';

const IndexPage = ({ data }) => {
  const isBrowser = () => typeof window !== 'undefined';
  const {
    introText,
    leadText,
    leadHeading,
    modularContent,
    tickerText,
    tickerItems,
    sliderHeading,
    sliderSubheading,
    slides,
    seoMetaTags,
    promoVideo,
    promoVideoMobile,
    promoVideoImage,
    newsHeading,
    newsText,
  } = data.datoCmsHome;
  return (
    <Layout seo={seoMetaTags}>
      {isBrowser && <Hero />}
      <BrandTicker items={tickerItems} heading={tickerText} />
      <Spacing pt={8} pb={4}>
        <Lines heading={introText} />
      </Spacing>
      <Spacing pt={4} pb={4}>
        <Lead heading={leadHeading} text={leadText} />
      </Spacing>
      <Video
        video={promoVideo}
        videoMobile={promoVideoMobile}
        image={promoVideoImage}
      />
      {data.allDatoCmsNews.nodes.length > 0 && (
        <Spacing pt={4} pb={4}>
          <Intro
            showIcon={false}
            heading={newsHeading}
            text={newsText}
            headingColor="dark"
            headingSize="md"
            button={[
              { text: 'View all news', page: { id: data.datoCmsGlobal.newsId } },
            ]}
          />
          <Spacing pt={3}>
            <Container size="lg" gutters>
              <NewsList items={data.allDatoCmsNews.nodes} />
            </Container>
          </Spacing>
        </Spacing>
      )}
      <Spacing pt={8} pb={4}>
        <Slider
          heading={sliderHeading}
          subheading={sliderSubheading}
          slides={slides}
          background="gradient"
          paddingTop={6}
        />
      </Spacing>
      {modularContent.length > 0 && <ModuleArea blocks={modularContent} />}
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query {
    datoCmsHome {
      id: originalId
      title
      introText
      newsHeading
      newsText
      leadHeading
      promoVideo {
        url
      }
      promoVideoMobile {
        url
      }
      promoVideoImage {
        gatsbyImageData(imgixParams: { fit: "crop", w: "1600", h: "900" })
      }
      leadText
      tickerText
      tickerItems {
        gatsbyImageData(imgixParams: { w: "105" })
        id: originalId
      }
      sliderHeading
      sliderSubheading
      slides {
        button {
          ...InternalLink
        }
        id: originalId
        heading
        image {
          gatsbyImageData(imgixParams: { fit: "crop", w: "1490", h: "660" })
        }
        mobileImage: image {
          gatsbyImageData(imgixParams: { fit: "crop", w: "686", h: "966" })
        }
      }
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      modularContent {
        ... on DatoCmsIntroBlock {
          ...IntroBlock
        }
        ... on DatoCmsCardGridBlock {
          ...CardGridBlock
        }
        ... on DatoCmsNumbersBlock {
          ...NumbersBlock
        }
        ... on DatoCmsTabsBlock {
          ...TabsBlock
        }
        ... on DatoCmsBlurbGridBlock {
          ...BlurbGridBlock
        }
      }
    }
    datoCmsGlobal {
      newsId: newsPageId
    }
    allDatoCmsNews(limit: 3, sort: { meta: { firstPublishedAt: DESC } }) {
      nodes {
        title
        slug
        id: originalId
        category {
          name
        }
        meta {
          firstPublishedAt(formatString: "DD MMMM YYYY")
        }
        image: heroImage {
          gatsbyImageData(
            imgixParams: { h: "500", w: "960", fit: "crop", q: 60 }
          )
          alt
        }
        description
      }
    }
  }
`;
